import { coursesInitState } from "./Courses";
import ACTION_TYPES from "../Actions/ActionTypes";

export function citiesReducer(state = coursesInitState.cities, action) {
  switch (action.type) {
    case ACTION_TYPES.GET_CITIES:
      return action.payload.data.data;
    default:
      return state;
  }
}
